<template>
  <div class="oc-modal-full-screen">
  <div  class="oc-modal">
    <div class="oc-modal-dialog" >

      <div class="oc-modal-content">
        <div class="oc-logo-container"><img src="@/assets/img/oneclose-logo.png" alt="OneClose"></div>
        <div class="oc-modal-header">
          <h5 class="oc-modal-title" >{{title}}
          <!--<span>-->
            <!--<img id="oc-modal-logo" src="@/assets/img/oneclose-logo.png"-->
                     <!--alt="OneClose Logo">-->
          <!--</span>-->
          </h5>

        </div>
        <div class="oc-modal-body" v-if="type==='extend' || type==='inactive'">
          <div class="row">
            <div class="col-12 oc-text">
            {{text}}
            </div>
          </div>
          <div class="row">
            <div class="col-12 oc-countdown">
            Session expires :{{runCountdown}}
            </div>
          </div>
        </div>


        <div class="oc-modal-body" v-else-if="type==='login'">
          <div class="row">
            <div class="col-12 oc-text">
              {{text}}
            </div>
            <div class="row">
            <div class="col-12 oc-countdown">
             Session expires :{{runCountdown}}
            </div>
            </div>
          </div>

          <div class="row form-group">
            <div class="col-2">
              <label for="login_password"> Username</label>
            </div>
            <div class="col-10">
              <input class="oc-username"
                     id="login_username"
                     required
                     ref="username"
                     v-bind:value="username"
                     name="username"
                     disabled
              >
            </div>
          </div>

          <div class="row form-group">
            <div class="col-2 ">
              <label for="login_password"> Password</label>
            </div>
            <div class="col-10">
                <input
                  class="oc-password"
                     id="login_password"
                     required
                     ref="loginPassword"
                     type="password"
                     v-model="password"
                     name="password"
                     @keyup.enter="okButtonHandler"
                     autocomplete="off"
              >
            </div>
          </div>

        </div>
        <div class="oc-modal-body" v-else>
          <div class="row">
            <div class="col-12">
              {{text}}
            </div>
          </div>
        </div>

        <div class="oc-modal-footer">
          <button type="button" class="btn btn-primary" @click="okButtonHandler" >{{okText}}</button>
          <button type="button" class="btn btn-secondary" data-dismiss="modal" @click="cancelButtonHandler" >{{cancelText}}</button>
        </div>
      </div>
    </div>
 </div>
  </div>

</template>

<script>
    export default {
      name: "OciSessionModal",
      data(){
        return {
          currentCount:0,
          timerInterval:null,
          password:"",
          modalCounterTypes:['login','extend','inactive'],
          countdownComplete:false,
          countdownStarted:false,
         }
      },
      props:{
        counter:{
          type:Number
        },
        timer:{
          type:Number
        },
        okText:{
         type:String
        },
        cancelText:{
         type:String
        },
        type:{
          type:String
        },
        text:{
          type:String
        },
        title:{
          type:String
        }
      },
      computed:{
         runCountdown(){
          if(this.currentCount===0){
             return "00:00";
          }
          else {
            //apply minute and seconds formatting
            return  this.$ociUtils.global.formatCountdown(this.currentCount);
          }
        },
        username(){

           return this.$store.getters.appUser.username;
        }
      },
      methods:{
        countdownTimer(){
          if(this.currentCount>0){
            --this.currentCount;
          }
          else if(this.currentCount==0){
            this.$emit("counterComplete")
            window.clearInterval(this.timerInterval)
            this.countdownComplete=true;
          }
        },
        //TODO add needed functionality
        cancelButtonHandler(){
        this.$emit("cancel")
         },
        //TODO add needed functionality . Call login dispatch
        okButtonHandler(){
          if(this.type === "login"){

            this.$emit('credentials',{userName:this.username,password:this.password})
          }
         this.$emit('ok')
         },
        modalClosed(){

        },
        initialize(){
           if(this.modalCounterTypes.includes(this.type)){
           this.currentCount = this.counter;
           this.timerInterval = setInterval(()=>{
             this.countdownTimer();
             this.countdownStarted=true;
           },990) //account for change in time a few milliseconds of slack
         }
        }
      },
      mounted(){
           this.$nextTick(()=>{
            this.initialize()
          })
      }
    }
</script>

<style scoped>
  .oc-logo-container{
    padding: 0 0 30px 0;
    margin: 0 auto;
    text-align: center;
  }
  .oc-modal {
    /*display: none; !*!* Hidden by default *!*!*/
    position: fixed; /* Stay in place */
    z-index: 100000; /* Sit on top */
    left: 0;
    top: 0;
    width: 100%; /* Full width */
    height: 100%; /* Full height */
    overflow: auto; /* Enable scroll if needed */
    background-color: rgba(0,125,194,1); /* OCI BLUE Fallback color */
    background-color: rgba(0,125,194,.97) ; /*!* OCI BLUE w/ opacity *!*/
  }

  /* Modal Content/Box */
  .oc-modal-content {
    background-color: #fefefe;
    margin: 15% auto; /* 15% from the top and centered */
    padding: 20px;
    border: 1px solid #888;
    width: 600px;; /* Could be more or less, depending on screen size */
  }
  .oc-modal-dialog{

  }
  .oc-modal-body{
    padding:10px ;
  }
  .oc-text{
    padding:0px 10px 10px 10px;
  }
  .oc-modal-title{
    padding:0px 10px 10px 10px;
  }
  .oc-countdown{
    padding:0px 10px 10px 20px;
  }
  .oc-username{
    font-size: 1em;
    width:80%;
   }
  .oc-password{
    font-size: 1em;
    width:80%;
  }
.oc-modal-footer{

}


  /* The Close Button */
  .oc-close {
    color: #aaa;
    float: right;
    font-size: 28px;
    font-weight: bold;
  }

  .oc-close:hover,
  .oc-close:focus {
    color: black;
    text-decoration: none;
    cursor: pointer;
  }
  .oc-modal-full-screen{

  }
  #oc-modal-logo{
    width:30%;
    height:30%;
    float:right;
  }

</style>
